include ../../../club/loading-table.mixin.pug

.fp-vertical-spacing.-s-sm
  .fp-vertical-spacing--line
    .fp-horizontal-spacing.-items-center
      .fp-horizontal-spacing--column.-expand
        h2.fp-title.-color-shade-700 {{ t('auctionsPage.exclusives.title') }}
      .fp-horizontal-spacing--column
        router-link.fp-link.-no-text-decoration(:to='{ name: \'createExclusive\', query: { auctionId }}' data-test='create-auction-exclusive')
          FairplayerButtonVue(icon='plus' :text='t(\'auctionsPage.exclusives.create\')')
  .fp-vertical-spacing--line(v-if='!hasExclusives' data-test='no-exclusives')
    p {{ t('auctionsPage.noExclusives') }}
  .fp-vertical-spacing--line(v-else)
    .fp-vertical-spacing--line.-align-center
      i.fp-icon.fp-glyph-close-circle.-s50.-color-shade-300
    .fp-vertical-spacing--line.-align-center
      .fp-vertical-spacing.-s-sm
        .fp-vertical-spacing--line
          .fp-text.-text-semi-bold.-text-lg {{ t('exclusivesPage.empty.title') }}
        .fp-vertical-spacing--line.-align-center {{ t('exclusivesPage.empty.noExclusives') }}
    .fp-vertical-spacing--line.-justify-center
      router-link.fp-link.fp-icon-with-text(:to='{ name: \'createExclusive\'}')
        i.fp-icon.fp-glyph-plus
        span {{ t('exclusivesPage.empty.create') }}
  .fp-vertical-spacing(v-else)
    .fp-vertical-spacing--line
      .fp-horizontal-spacing.-items-center
        .fp-horizontal-spacing--column.-expand
          input.fp-input-text(v-model='terms' :placeholder='t(\'exclusivesPage.search\')' data-test='terms-input')
        .fp-horizontal-spacing--column
          .fp-checkable-element
            .fp-checkable-element--checkbox
              input.fp-checkbox#visible-checkbox(v-model='showNotVisibleExclusives' type='checkbox' data-test='visibility-checkbox')
            .fp-checkable-element--label
              label(for='visible-checkbox') {{ t('auctionsPage.exclusives.showNotVisibleExclusives') }}
    .fp-vertical-spacing--line
      p(v-if='!filteredExclusives.length' data-test='no-filtered-exclusives') {{ t('exclusivesPage.noResults') }}
      table.fp-table.-with-actions(v-if='filteredExclusives.length' data-test='exclusives-table')
        thead
          tr
            th.-shrink
            th {{ t('exclusivesPage.table.slug') }}
            th {{ t('exclusivesPage.table.category') }}
            th {{ t('exclusivesPage.table.startingPrice') }}
            th {{ t('exclusivesPage.table.bids') }}
            th {{ t('exclusivesPage.table.likes') }}
            th.-shrink
        tbody
          AuctionExclusiveRowVue(v-for='(exclusive, index) in filteredExclusives' :key='index' :exclusive='exclusive' :index='index')
